// =============================================================================
// requests/kpiRequests.js
//
// Chamadas HTTP a API de KPI. Padrao: Same as trackerRequests.js / weeklyUpdateRequests.js.
//   - Cada funcao faz UMA chamada a UM endpoint
//   - Devolvem a Promise do Axios
//   - Nenhuma funcao toca no state ou no dispatch
// =============================================================================
import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest.js';

const BASE = config.API_URL + 'kpi';

// =============================================================================
// Incidents
// =============================================================================

// Devolve TODOS os incidentes (sem filtros). Filtragem feita client-side.
export function apiFetchIncidents() {
	return AxiosRequest({
		method: 'GET',
		url:    BASE + '/incidents',
	});
}

export function apiFetchIncidentHistory(incidentId) {
	return AxiosRequest({
		method: 'GET',
		url:    BASE + '/incidents/' + incidentId + '/history',
	});
}

// =============================================================================
// Lookups (vendors, techs, kpis, severities, statuses da BD)
// =============================================================================

export function apiFetchLookups() {
	return AxiosRequest({ method: 'GET', url: BASE + '/lookups' });
}

// =============================================================================
// KPI Rules
// =============================================================================

export function apiFetchRules() {
	return AxiosRequest({ method: 'GET', url: BASE + '/rules' });
}

export function apiFetchRuleById(id) {
	return AxiosRequest({ method: 'GET', url: BASE + '/rules/' + id });
}

export function apiCreateRule(rule) {
	return AxiosRequest({ method: 'POST', url: BASE + '/rules', data: rule });
}

export function apiUpdateRule(id, rule) {
	return AxiosRequest({ method: 'PUT', url: BASE + '/rules/' + id, data: rule });
}

export function apiDeleteRule(id) {
	return AxiosRequest({ method: 'DELETE', url: BASE + '/rules/' + id });
}

// =============================================================================
// Formula validation
// =============================================================================

export function apiValidateFormula(payload) {
	return AxiosRequest({
		method: 'POST',
		url:    BASE + '/rules/validate',
		data:   payload,
	});
}

// =============================================================================
// Engine
// =============================================================================

export function apiFetchEngineLogs() {
	return AxiosRequest({ method: 'GET', url: BASE + '/engine/logs' });
}

export function apiRunBaseline(date) {
	return AxiosRequest({
		method: 'POST',
		url:    BASE + '/engine/baseline',
		params: { date: date },
	});
}

export function apiRunDetection(date) {
	return AxiosRequest({
		method: 'POST',
		url:    BASE + '/engine/detection',
		params: { date: date },
	});
}

export function apiRunFullPipeline(date) {
	return AxiosRequest({
		method: 'POST',
		url:    BASE + '/engine/run',
		params: { date: date },
	});
}

// =============================================================================
// Sites com coordenadas (alimenta o mapa)
// =============================================================================
export function apiFetchSites() {
	return AxiosRequest({ method: 'GET', url: BASE + '/sites' });
}